import React, { useEffect, useState } from "react";
import NewStarterPayrollForm from "../../components/forms/NewStarterPayrollForm";
import { db } from "../../firebase";
import { doc, getDoc, setDoc, serverTimestamp } from "firebase/firestore";
import { useAuth } from "../../context/AuthContext";
import { getUserDocId } from "../../utils/userDocId";

export default function NewStarterPayrollPage() {
  const { user } = useAuth();
  const [loading, setLoading] = useState(true);
  const [existingDoc, setExistingDoc] = useState(null);

  useEffect(() => {
    if (!user) return;
    const fetchDoc = async () => {
      const userId = getUserDocId(user);
      const ref = doc(db, "users", userId, "complianceDocs", "newStarterPayroll");
      const snap = await getDoc(ref);
      if (snap.exists()) setExistingDoc({ id: snap.id, ...snap.data() });
      setLoading(false);
    };
    fetchDoc();
  }, [user]);

  const handleSubmit = async (data) => {
    if (!user) return;
    const userId = getUserDocId(user);

    await setDoc(
      doc(db, "users", userId, "complianceDocs", "newStarterPayroll"),
      {
        ...data,
        name: "New Starter Payroll Form",
        renewal: "As Required",
        status: "submitted",
        verified: existingDoc?.verified || false,
        lastUpdated: serverTimestamp(),
      },
      { merge: true }
    );

    alert("New starter payroll form submitted.");
  };

  if (loading) {
    return <div style={{ padding: 20 }}>Loading…</div>;
  }

  if (existingDoc?.verified) {
    return (
      <div style={{ padding: 20, maxWidth: 800, margin: "0 auto" }}>
        <h3 style={{ fontSize: 18, fontWeight: 600, marginBottom: 8 }}>
          New Starter Payroll Form
        </h3>
        <p style={{ fontSize: 14, color: "#16a34a", marginBottom: 8 }}>
          ✅ This form has been verified by admin. You cannot edit it.
        </p>
        <p style={{ fontSize: 13, color: "#4b5563" }}>
          For any changes, please contact the office.
        </p>
      </div>
    );
  }

  return (
    <div style={{ padding: 16, maxWidth: 800, margin: "0 auto" }}>
      <NewStarterPayrollForm onSubmit={handleSubmit} initialData={existingDoc} />
    </div>
  );
}
